
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetokonkandarshaninnova() {



    const cardData =
    {
        keyword: 'Pune to Konkan Darshan Innova Crysta Cab',
        heading: 'Meghana Cab : Pune to Konkan Darshan Innova Crysta Cab',
        headingDescription: 'Meghana Cab offers Pune to Konkan Darshan Innova Crysta Cab Service, delivering a luxurious, spacious, and scenic road trip along Maharashtra’s breathtaking Konkan coast. Covering coastal gems such as Alibaug, Ganpatipule, Tarkarli, Ratnagiri, and Dapoli, our Innova Crysta vehicles provide plush leather interiors, ample legroom, generous luggage space, and full air-conditioning—ideal for multi-day leisure travel . Whether you are looking for a relaxed family getaway, a beachside retreat, or a cultural exploration, our expert chauffeurs know the best coastal routes, ghat roads like Tamhini and Varandha, and scenic stopovers including waterfalls and forts. With door-to-door pickup from Pune, flexible one-way, round-trip, or customized itineraries, GPS-enabled cars, and prompt 24/7 support, Meghana Cab ensures your Pune to Konkan Darshan Innova Crysta journey is smooth, memorable, and wrapped in comfort from start to finish.',


        top: ' Top Places to Visit in Konkan with Meghana Cab',

"topPlaces": [
  {
    "title": "Alibaug & Kolaba Fort",
    "description": "A favorite weekend escape from Mumbai, Alibaug offers coconut-lined beaches and easy water sports. Kolaba Fort, accessible on foot at low tide, features sea-facing temples and freshwater wells—ideal for beach lovers and history enthusiasts."
  },
  {
    "title": "Ganpatipule & Aare‑Ware Beach",
    "description": "Home to the self-manifested Ganpatipule Temple on silvery sands, this beach draws pilgrims and sunseekers alike. Just south lies Aare-Ware, a quieter cove known for dramatic cliffs and tranquil waters."
  },
  {
    "title": "Harihareshwar & Shrivardhan",
    "description": "Called the 'Dakshin Kashi', Harihareshwar combines two ancient Shiva temples with wide sandy shores. Nearby Shrivardhan features a well-kept promenade, seaside charm, and refreshing sea breezes."
  },
  {
    "title": "Tarkarli & Malvan (Sindhudurg Fort)",
    "description": "A pristine coastal stretch with ultra-clear waters perfect for scuba diving and snorkeling. Visit the 17th-century island fortress Sindhudurg Fort and savor authentic Malvani cuisine in the charming town of Malvan."
  },
  {
    "title": "Dapoli & Offbeat Beaches",
    "description": "Known as Konkan’s ‘Mini-Goa’, Dapoli is dotted with unspoilt beaches like Anjarle, Ladghar, and Kelshi. Ideal for beach hopping, dolphin spotting, and tranquil homestays."
  },
  {
    "title": "Bhogwe & Aaravi",
    "description": "Hidden near Devbag, these twin beaches lie where the Karli River meets the Arabian Sea. With crystal-clear waters and lush backdrops, they offer peace and solitude far from tourist crowds."
  },
  {
    "title": "Vengurla",
    "description": "Located just north of Goa, Vengurla’s semi-circular bay is framed by lush hills. Its lighthouse, bustling fishing jetty, and offshore islet (Burnt Island) offer ideal spots for bird watching and sunsets."
  },
  {
    "title": "Raigad Fort & Phansad Wildlife Sanctuary",
    "description": "Beyond beaches, explore Raigad—the historic hill fort of Chhatrapati Shivaji—via ropeway or trek. Nearby Phansad Sanctuary adds forest trails and rich birdlife to your journey."
  }
],

   "services": [
    {
      "name": "Pune to Konkan Darshan Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Konkan for a memorable coastal tour. Enjoy panoramic views, smooth highways, and lush green landscapes while traveling in a spacious, air-conditioned vehicle with a professional chauffeur ensuring a safe and relaxing trip."
    },
    {
      "name": "One Way Innova Crysta Pune Konkan",
      "description": "Opt for a one-way Innova Crysta cab service from Pune to Konkan. This is perfect for vacationers staying in Konkan or continuing onward, with the benefit of no return fare charges."
    },
    {
      "name": "Round Trip Innova Crysta Pune Konkan",
      "description": "Planning to return the same or next day? Choose our round-trip Innova Crysta cab service with flexible return timings, same vehicle assurance, and added convenience for your complete Konkan journey."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Konkan",
      "description": "Travel in total comfort with our air-conditioned Innova Crysta taxi. Stay cool as you journey through the scenic coastal routes of Maharashtra's Konkan belt."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Konkan",
      "description": "Enjoy a relaxed journey with our chauffeur-driven Innova Crysta service. Experienced drivers ensure safety, punctuality, and a smooth ride from Pune to Konkan."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Konkan",
      "description": "Book a private Innova Crysta cab for your exclusive group. Whether it’s a family trip or a group of friends, enjoy full privacy, flexible stops, and premium comfort."
    },
    {
      "name": "Online Booking Innova Crysta Pune Konkan",
      "description": "Reserve your Pune to Konkan cab online in minutes. Our seamless booking platform offers real-time availability, instant confirmations, and upfront pricing for peace of mind."
    },
    {
      "name": "Konkan Sightseeing Innova Crysta",
      "description": "Explore beaches, forts, temples, and scenic viewpoints of Konkan in a dedicated sightseeing cab. Ideal for leisure tours, family vacations, and heritage exploration in ultimate comfort."
    },
    {
      "name": "Comfortable Innova Crysta Cab Pune Konkan",
      "description": "Our Innova Crysta cabs offer wide seats, ample legroom, smooth suspension, and a quiet cabin—ensuring a comfortable long journey from Pune to Konkan."
    },
    {
      "name": "Budget Innova Crysta Taxi Pune Konkan",
      "description": "Get great value for your money with our budget-friendly Innova Crysta cab service. Premium comfort and reliable vehicles at competitive prices for your Konkan tour."
    },
    {
      "name": "Family Trip Innova Crysta Konkan",
      "description": "Perfect for family travel, our Innova Crysta cabs come with 6–7 seater options, child-friendly space, luggage room, and secure travel for a memorable family trip to Konkan."
    },
    {
      "name": "Long Distance Innova Crysta Taxi",
      "description": "Our Innova Crysta taxis are designed for long-distance travel like Pune to Konkan with superior stability, comfort, and reliability for journeys lasting multiple hours."
    },
    {
      "name": "Reliable Innova Crysta Taxi Konkan",
      "description": "Depend on our trusted service for timely pickups, professional drivers, and clean, well-maintained vehicles. A perfect match for Konkan's winding coastal roads."
    },
    {
      "name": "Weekend Trip Innova Crysta Konkan",
      "description": "Escape the city on a weekend trip to Konkan in our luxurious Innova Crysta. Plan your short break with ease and travel in comfort with flexible return options."
    },
    {
      "name": "Konkan Beach Trip Innova Crysta",
      "description": "Planning a beach vacation? Our Innova Crysta cab is ideal for visiting Konkan's famous beaches like Ganpatipule, Harihareshwar, and Tarkarli in spacious, beach-trip-ready comfort."
    }
  ],
  "tableData": [
    ["Pune to Konkan Darshan Innova Crysta Cab Booking", "One Way Innova Crysta Pune Konkan"],
    ["Round Trip Innova Crysta Pune Konkan", "AC Innova Crysta Taxi Pune Konkan"],
    ["Chauffeur Driven Innova Crysta Pune Konkan", "Private Innova Crysta Taxi Pune Konkan"],
    ["Online Booking Innova Crysta Pune Konkan", "Konkan Sightseeing Innova Crysta"],
    ["Comfortable Innova Crysta Cab Pune Konkan", "Budget Innova Crysta Taxi Pune Konkan"],
    ["Family Trip Innova Crysta Konkan", "Long Distance Innova Crysta Taxi"],
    ["Reliable Innova Crysta Taxi Konkan", "Weekend Trip Innova Crysta Konkan"],
    ["Konkan Beach Trip Innova Crysta", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta Cab for Pune to Konkan Darshan",
    "WhyChoosedescription": "Embark on a mesmerizing journey through the scenic Konkan coastline with our premium Innova Crysta cab service from Pune. Whether you're visiting Ganpatipule, Ratnagiri, Dapoli, Malvan, or Sindhudurg, enjoy comfort, convenience, and stunning views throughout your coastal darshan tour."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable for Long-Distance Coastal Travel",
    "WhyChoosedescription": "The Innova Crysta is perfect for hilly terrain and winding roads of the Konkan region. With plush seating, powerful AC, and generous luggage space, it ensures a relaxed travel experience even on multi-day trips with your family or group."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Konkan Routes",
    "WhyChoosedescription": "Our drivers are familiar with the narrow coastal roads, ghats, and hidden gems of Konkan. They ensure safe driving, timely arrivals, and can help you navigate between remote villages, temples, beaches, and historical sites with ease."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained & Sanitized Vehicles",
    "WhyChoosedescription": "Every Innova Crysta is thoroughly sanitized before departure. We maintain the highest hygiene standards and vehicle upkeep to ensure a safe and smooth ride throughout your Konkan darshan journey."
  },
  {
    "WhyChooseheading": "Customized Itineraries for Spiritual, Scenic or Cultural Tours",
    "WhyChoosedescription": "From beachside temples like Ganpatipule and Kunkeshwar to sea forts like Sindhudurg and Vijaydurg, we help you craft the perfect itinerary. Choose a spiritual darshan tour, heritage trail, or nature-focused retreat—customized to your pace and interest."
  },
  {
    "WhyChooseheading": "All-Inclusive Transparent Pricing",
    "WhyChoosedescription": "Our pricing includes tolls, driver allowance, fuel, and taxes. Get a clear and honest quote with no hidden charges—ideal for planning multi-day Konkan vacations without financial surprises."
  },
  {
    "WhyChooseheading": "Ideal for Family Vacations, Pilgrimages, and Nature Getaways",
    "WhyChoosedescription": "Whether you're exploring coastal temples, relaxing at untouched beaches, or enjoying local seafood and Konkan culture, our Innova Crysta cab service offers the comfort and flexibility needed for every kind of traveler."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Tour Assistance",
    "WhyChoosedescription": "Our travel support team is available any time to assist with bookings, changes, route guidance, or emergencies. We help you plan your Pune to Konkan trip smoothly from start to finish."
  }
]
























    }

const faqData = [
    {
        question: "How do I book an Innova Crysta for Pune to Konkan Darshan?",
        answer: "You can book easily by calling Meghana Cab at +91 9075462128 or through our website for a hassle-free reservation."
    },
    {
        question: "Which destinations are covered under Konkan Darshan from Pune?",
        answer: "Popular destinations include Ganpatipule, Ratnagiri, Dapoli, Harihareshwar, Diveagar, and Sindhudurg. The route can be customized based on your preferences."
    },
    {
        question: "Is Innova Crysta suitable for long Konkan road trips?",
        answer: "Yes, the Innova Crysta is ideal for long drives with its spacious interiors, powerful performance, and smooth ride quality."
    },
    {
        question: "Can I book a multi-day Konkan tour with Innova Crysta?",
        answer: "Yes, we offer flexible multi-day packages for Konkan Darshan with comfortable overnight travel options."
    },
    {
        question: "Are the drivers experienced with Konkan routes?",
        answer: "Absolutely. Our drivers are well-versed with Konkan's coastal and ghat routes for a safe and smooth journey."
    },
    {
        question: "Is the vehicle sanitized before every trip?",
        answer: "Yes, we sanitize our vehicles thoroughly before every journey to ensure passenger safety and hygiene."
    },
    {
        question: "What is included in the Konkan Darshan cab fare?",
        answer: "The fare includes fuel, driver charges, and tolls. Extra charges may apply for parking or extended stopovers."
    },
    {
        question: "Can I customize my itinerary and stops during the trip?",
        answer: "Yes, you can fully customize your travel plan and request stops for sightseeing, meals, or overnight stays."
    },
    {
        question: "How many people can travel in one Innova Crysta?",
        answer: "The Innova Crysta comfortably accommodates 6 to 7 passengers along with luggage."
    },
    {
        question: "What payment options do you accept for Konkan bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Nilesh Patankar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We explored the beautiful Konkan coastline in an Innova Crysta booked through Meghana Cab. The ride was smooth, and the driver knew all the scenic spots.”',
    },
    {
        name: 'Ms. Sheetal Naik',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly satisfied with the service. The vehicle was clean and luxurious — perfect for our family Konkan Darshan. Will definitely book again!”',
    },
];







































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const puneToKonkanSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Konkan Darshan Innova Crysta Cab",
  "description": "Book a reliable and comfortable chauffeur-driven AC Innova Crysta taxi from Pune to Konkan for sightseeing, beach trips, and weekend getaways. One way and round trip options with easy online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Sightseeing Taxi Service",
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Konkan"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-konkan-darshan-innova-crysta-cab"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Konkan Darshan Innova Crysta Cab | Comfortable Beach & Sightseeing Taxi</title>
  <meta
    name="description"
    content="Chauffeur-driven Innova Crysta cab service from Pune to Konkan for sightseeing, beach trips, and weekend outings. Book your one way or round trip AC taxi online now."
  />
  <meta
    name="keywords"
    content="Pune to Konkan Darshan Innova Crysta Cab Booking, One Way Innova Crysta Pune Konkan, Round Trip Innova Crysta Pune Konkan, AC Innova Crysta Taxi Pune Konkan, Chauffeur Driven Innova Crysta Pune Konkan, Private Innova Crysta Taxi Pune Konkan, Online Booking Innova Crysta Pune Konkan, Konkan Sightseeing Innova Crysta, Comfortable Innova Crysta Cab Pune Konkan, Budget Innova Crysta Taxi Pune Konkan, Family Trip Innova Crysta Konkan, Long Distance Innova Crysta Taxi, Reliable Innova Crysta Taxi Konkan, Weekend Trip Innova Crysta Konkan, Konkan Beach Trip Innova Crysta"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToKonkanSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/4.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetokonkandarshaninnova;